import { z } from 'zod'

/** Missing, null, or blank → null; otherwise must be a valid http(s) URL. */
const itemExternalUrlField = z.preprocess(
  (val: unknown) => {
    if (val === undefined || val === null) return null
    if (typeof val !== 'string') return val
    const t = val.trim()
    return t === '' ? null : t
  },
  z.union([z.string().url().max(2048), z.null()]),
)

export const CreateItemRequest = z.object({
  title: z.string().min(1).max(200),
  description: z.string().max(4000).nullable().optional(),
  priceCents: z.number().int().positive().max(10_000_000),
  externalUrl: itemExternalUrlField.optional(),
  imageId: z.string().nullable().optional(),
})
export type CreateItemRequest = z.infer<typeof CreateItemRequest>

export const UpdateItemRequest = CreateItemRequest.partial().extend({
  hidden: z.boolean().optional(),
  offered: z.boolean().optional(),
})
export type UpdateItemRequest = z.infer<typeof UpdateItemRequest>

export const FromUrlRequest = z.object({
  url: z.string().url().max(2048),
})

export const FromUrlResponse = z.object({
  title: z.string(),
  description: z.string().nullable(),
  priceCents: z.number().int().nullable(),
  externalUrl: z.string().url(),
  imageCandidates: z.array(z.string().url()).max(8),
})
export type FromUrlResponse = z.infer<typeof FromUrlResponse>

export const ReorderRequest = z.object({
  orderedIds: z.array(z.string()).min(1),
})

export const Item = z.object({
  id: z.string(),
  title: z.string(),
  description: z.string().nullable(),
  priceCents: z.number().int(),
  imageUrl: z.string().url().nullable(),
  externalUrl: z.string().url().nullable(),
  outUrl: z.string(),
  hidden: z.boolean(),
  offered: z.boolean(),
  sortOrder: z.number().int(),
  alreadyGivenCents: z.number().int(),
  remainingCents: z.number().int(),
  complete: z.boolean(),
})
export type Item = z.infer<typeof Item>
